module.exports = __webpack_public_path__ + "static/lunch-learn-8c719e44604b43cc81c61aa770d62fea.png";